module.exports = __webpack_public_path__ + "media/desert_storm.382d0433.webm";